var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.placeholder") } },
    [
      _c("el-input", {
        attrs: { type: "text" },
        model: {
          value: _vm.optionModel.placeholder,
          callback: function ($$v) {
            _vm.$set(_vm.optionModel, "placeholder", $$v)
          },
          expression: "optionModel.placeholder",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }